<template>
  <div class="home">
    <div class="top">
      <img src="../assets/logo.jpeg"  class="logo">
      <div class="title"> 河北正定中学-明厨亮灶系统</div>
     </div>
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld
  }
}
</script>
<style scoped>
.top{
  height: 80px;display: flex;border-bottom: 1px solid #dedede;
}
.logo{
  margin-left: 30px; width: 60px;padding: 10px;
}
.title{
  height: 80px;font-size: 26px;line-height: 80px;margin-left: 10px;
}
@media (max-width: 767px) {
  .top{
    position: fixed;
    z-index: -999999;
    display: none;
  }
.logo{
  margin-left: 0px; width: 60px;padding: 10px;
}
.title{
  height: 80px;font-size: 20px;line-height: 80px;margin-left: 5px;
}

}
</style>
